import {useState} from 'react'
import DataExportMasterDataTemplate from '../../components/5templates/DataExportMasterDataTemplate'
import ApiService from '../../common/ApiCalls'
import {downloadCsvData} from '../../services/util/miscellaneousService'

const DataExportMasterData = () => {
    const [dataSetType, setDataSetType] = useState('')
    const onDataSetTypeChange = (newValue) => {
        setDataSetType(newValue)
    }

    const [isErrorSnackbarOpen, setIsErrorSnackbarOpen] = useState(false)

    const handleExportButton = async () => {
        switch(dataSetType){
            case 'List of all Locations':
                await downloadCsvData(ApiService().getAllLocationsCsvData, setIsErrorSnackbarOpen, 'locations')
                break
            case 'List of all Contacts':
                await downloadCsvData(ApiService().getAllContactsCsvData, setIsErrorSnackbarOpen, 'contacts')
                break
            case 'List of all Services':
                await downloadCsvData(ApiService().getAllServicesCsvData, setIsErrorSnackbarOpen, 'services')
                break
            case 'List of all Clients':
                await downloadCsvData(ApiService().getAllClientsCsvData, setIsErrorSnackbarOpen, 'clients')
                break
            default:
                console.log('There is an error')
        }
    }

    const disabled = (step) => {
        switch (step) {
            case 0:
                return dataSetType === ''
            default:
                return false
        }
    }

    return (
        <DataExportMasterDataTemplate dataSetType={dataSetType} onDataSetTypeChange={onDataSetTypeChange}
                                      handleExportButton={handleExportButton} disabled={disabled}
                                      isErrorSnackbarOpen={isErrorSnackbarOpen} setIsErrorSnackbarOpen={setIsErrorSnackbarOpen}/>
    )
}

export default DataExportMasterData